export const modalConstants = {
  CONTAINER_ID: 'sentisis-app',
}
